import { Button, Tooltip } from "antd"
import { NotebookPen } from "lucide-react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { ExamPeriodMonitorState, Report } from "@types"
import { getKeycloakRealm } from "../helpers"

interface Props {
    report: Report
}

export const ReportTableActions = ({report}: Props) => {

    const {t} = useTranslation()
    const navigate = useNavigate()

    return (
        report.examInstanceState === ExamPeriodMonitorState.Completed && (
            <Tooltip title={t("pages.examPeriods.gradeExam")} placement="right">
            <Button
              type="dashed"
              icon={<NotebookPen />}
              onClick={() =>
                navigate(`/${getKeycloakRealm}/exam-periods/correction/${report.id}`)
              }
            />
          </Tooltip>)
    )
}